import script from "./AjudaIconComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AjudaIconComponent.vue?vue&type=script&setup=true&lang=js"

import "./AjudaIconComponent.vue?vue&type=style&index=0&id=005972de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-005972de"]])

export default __exports__